import { useMutation } from '@tanstack/react-query';
import saveAs from 'file-saver';

import { constants } from '../constants';
import { APIError } from '../services/network/types';
import { t } from '../services/translation/translation';

const downloadInvoiceAnonymous = async ({ tripKey, jwtToken }: { tripKey: string; jwtToken: string }) => {
  const response = await fetch(`${constants.passengerApi}/anonymous/v1/invoice?tripKey=${tripKey}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  });

  if (!response.ok) {
    throw { type: 'api', message: t('network.server-error') } satisfies APIError;
  }

  const blob = await response.blob();

  // Télécharge le fichier
  saveAs(blob, `${tripKey}.pdf`);
};

export const useDownloadInvoiceAnonymous = () =>
  useMutation((params: { tripKey: string; jwtToken: string }) => downloadInvoiceAnonymous(params));
